module.exports = __webpack_public_path__ + "2e87d48c59b736582a7f05c6f7f68e71.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/tuxedo.png
// module id = 1959
// module chunks = 0